/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventprivatefeaturedescription3Inputs */

const en_eventprivatefeaturedescription3 = /** @type {(inputs: Eventprivatefeaturedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite or link only. Not shown in search or the feed.`)
};

const de_eventprivatefeaturedescription3 = /** @type {(inputs: Eventprivatefeaturedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur mit Einladung oder Link. Erscheint nicht in der Suche und im Feed.`)
};

/**
* | output |
* | --- |
* | "Invite or link only. Not shown in search or the feed." |
*
* @param {Eventprivatefeaturedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventprivatefeaturedescription3 = /** @type {((inputs?: Eventprivatefeaturedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventprivatefeaturedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventprivatefeaturedescription3(inputs)
	return de_eventprivatefeaturedescription3(inputs)
});
export { eventprivatefeaturedescription3 as "eventPrivateFeatureDescription" }